import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="resumin--popover"
export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.clickOutsideHandler = this._clickOutSide.bind(this);
    document.addEventListener("click", this.clickOutsideHandler);
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler);
  }

  toggle(e) {
    e.preventDefault();
    this.contentTarget.classList.toggle("visible");
  }

  _clickOutSide(event) {
    if (
      !this.element.contains(event.target) &&
      this.contentTarget.classList.contains("visible")
    ) {
      this.contentTarget.classList.remove("visible");
    }
  }
}
